import React, { useRef, useState } from 'react'
import "./NotificationItem.css"
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleAcceptAd, handleRejectAd } from '../../features/User/UserAction';
import userApi from '../../Common/Api/UserApi'
import Cookies from 'js-cookie';
export default function NotificationItem(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [bookImages,setBookImages]=useState([]);
  const [showText,setShowText] = useState(true);

  const handleAcceptPrice = () => {
    alert("Price Accepted , Your Request is sent to the Admin");
    dispatch(handleAcceptAd({ adId: props.id }))
    navigate("/dashboard/")
  }
  const handleRejectPrice = () => {
    alert("Price Rejected , Your Request is sent to the Admin");
    dispatch(handleRejectAd({ adId: props.id }))
    navigate("/dashboard/")
  }

  const imageRef = useRef();

  const onImageChange = (e) => {
      
      e.preventDefault()
      if (e.target.files.length) {
      
          let imageArr = bookImages;
          imageArr = [...imageArr,...e.target.files]

          setBookImages(imageArr);
          
      }

  }

  const removeImg = (image)=>{
      let imageArr=[];
      imageArr = bookImages.filter((item)=>item!==image)
      setBookImages(imageArr);

      setShowText(!(imageArr.length>0));
      var e = window.event;
      
      
      e.stopPropagation();
  }

  const handleChangePhotos=async()=>{
    if(bookImages.length<5)
    {
        alert('Please Provide 5 photos of the book !');
        return;
    }

    const data = new FormData();
    for(var x = 0; x<bookImages.length; x++) {
        data.append('images', bookImages[x])
    }

    const res = await userApi.post(`/user/ads/${props.id}/edit-images`,data,{
      headers: {
        'Authorization':`Bearer ${Cookies.get('token')}`,
     }
    })

    console.log("res from edit images route : ",res);
  }

  return (
    <div className='notification-Ad-card'>
      <div className='notification-Ad-img-container'>
        <img src={props.img} alt="" className='notification-Ad-img' />
      </div>
      <span className='notificationviewAdBtn' style={{ textAlign: "center" }}><strong>Quoted Price </strong>: {props.quotedPrice} Rs</span>
      <span className='notificationviewAdtext' style={{ textAlign: "center" }}><strong>From Admin</strong>  : {props.message}</span>
      {props.accepted && <span className='notificationviewAdtext' style={{ textAlign: "center" }}><strong>Under Processing</strong></span>
      }
      {
         !props.accepted &&
        <div>
          <div className="NotificationsBtns">
            <button className='notificationviewAdBtn' id='AcceptBtn' onClick={handleAcceptPrice} >Accept Price</button>
            <button className='notificationviewAdBtn' id='RejectBtn'onClick={handleRejectPrice} >Reject Price</button>

          </div>
          <div>
            <button className='notificationviewAdBtn' id='changePhotosBtn' data-bs-toggle="modal" data-bs-target="#exampleModal" >Change Photos</button>

          </div>
        </div>
      }

      {/* <!-- Modal --> */}
      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
          <div className="modal-content">
          <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">Change AD Photos</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{height:'250px'}}>
              <div className='modal-container' style={{padding:'0'}} >
                  
                  <div className='ad-form-comp'>
                    <label>Add Images of Book  (Exact 5)</label>
                      <input type="file" id="add-single-img" accept="image/jpeg" multiple className='img-input' onChange={onImageChange} ref={imageRef}/>
                    
                      <div id="input-img-container"  onClick={() => imageRef.current.click() }>
                          
                          <div className={(showText)?'image-input-text show':'image-input-text'}>+ Add photos</div>
                          { bookImages.map((element)=>{
                          return(
                              <div className='preview-img-cont' key={element.lastModified}>
                                  <i className="fa-regular fa-circle-xmark remove-img" onClick={()=>removeImg(element)}></i>
                                  <img src={ URL.createObjectURL(element)} alt="Preview" className='preview-img' />
                              </div>
                          )
                          })} 
                          
                    </div>
                  </div>
        
              </div>
          </div>
          <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="submit" className="btn btn-primary form-btn" data-bs-dismiss="modal" onClick={handleChangePhotos}>Save changes</button>
          </div>
          </div>
      </div>
      </div>
    </div>
  )
}
